import { DataServer } from "../../../../sensorconfig.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

interface SaveThreysholdState {
    SaveThreyshold: {
        load: boolean;
        data: [];
    };
}

export const SaveThreysholdSlice = createSlice({
    name: "SaveThreyshold",
    initialState: {
        SaveThreyshold: {
            load: false,
            data: [],
        },
    } as SaveThreysholdState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(getThreysholdValue.pending, (state: SaveThreysholdState) => {
                state.SaveThreyshold.load = true;
            })
            .addCase(getThreysholdValue.fulfilled, (state: SaveThreysholdState, action: any) => {
                state.SaveThreyshold.data = action.payload;
                state.SaveThreyshold.load = false;
            })
            .addCase(getThreysholdValue.rejected, (state: SaveThreysholdState) => {
                state.SaveThreyshold.load = false;
            })
    },
});

export default SaveThreysholdSlice.reducer;

export const addThreyshold = createAsyncThunk(
    "users/addThreyshold",
    async (param: { apiParam: { data: any } }, thunkAPI) => {
        try {
            const { data } = await DataServer.post("/api/setting/v1/", {
                ...param.apiParam.data
            });

            toast.success(data.message,{theme: "colored"});

            return data.data;
        } catch (error) {
        }
    }
);

export const getThreysholdValue = createAsyncThunk(
    "RtssReport/getThreysholdValue",
    async (param: any) => {
      try {
        var data: any;
        data = await DataServer.get("/api/setting/v1/?warehouse_id=" + param.apiParam.warehouse_id);
        return data.data;
      } catch (error) {
        return error;
      }
    }
  );